const customSelect = () => {
  const customSelects = document.getElementsByClassName('js-zip');

  if (customSelects.length === 0) return;
    //@ts-ignore
    function closeAllSelect(elmnt) {
      const selectItems = document.getElementsByClassName('select-items');
      const selectSelected = document.getElementsByClassName('select-selected');
      const arrNo = [];
      for (let i = 0; i < selectSelected.length; i++) {
        if (elmnt == selectSelected[i]) {
          //@ts-ignore
          arrNo.push(i);
        } else {
          selectSelected[i].classList.remove('select-arrow-active');
        }
      }
      for (let i = 0; i < selectItems.length; i++) {
        //@ts-ignore
        if (!arrNo.includes(i)) {
          selectItems[i].classList.add('select-hide');
        }
      }
    }

    const address1Select = document.querySelector('select[name="address1"]') as HTMLInputElement;

    let lastSelectedText = '';

    function handleAddressData() {
      //@ts-ignore
      const selectedOption = address1Select.options[address1Select.selectedIndex];
      const selectedText = selectedOption.text;
    
      if (selectedText !== lastSelectedText) {
        // Update other parts of your website with the selectedText as needed
        lastSelectedText = selectedText;
        //@ts-ignore
        document.getElementById('address12')?.textContent = selectedText;
      }
    }

    // Check every 100 milliseconds (adjust as needed)
    setInterval(handleAddressData, 100);

    const btn = document.querySelector('.contact__form-zip-btn');

    btn?.addEventListener('click', () => {
      //@ts-ignore
      AjaxZip3.zip2addr('zip', '', 'address1', 'address2');
    });


    for (let i = 0; i < customSelects.length; i++) {
      const selectElmnt = customSelects[i].getElementsByTagName('select')[0];
      const selectLength = selectElmnt.length;

      const selectedDiv = document.createElement('DIV');
      selectedDiv.setAttribute('class', 'select-selected');
      selectedDiv.setAttribute('id', 'address12');
      customSelects[i].appendChild(selectedDiv);
      selectedDiv.innerHTML = selectElmnt.options[selectElmnt.selectedIndex].innerHTML;
      

      const optionsDiv = document.createElement('DIV');
      optionsDiv.setAttribute('class', 'select-items select-hide');
      for (let j = 1; j < selectLength; j++) {
        const optionDiv = document.createElement('DIV');
        optionDiv.innerHTML = selectElmnt.options[j].innerHTML;
        optionDiv.addEventListener('click', function () {
          selectElmnt.selectedIndex = j;
          selectedDiv.innerHTML = this.innerHTML;
          //@ts-ignore
          const sameAsSelected = this.parentNode.getElementsByClassName('same-as-selected');
          for (let k = 0; k < sameAsSelected.length; k++) {
            sameAsSelected[k].removeAttribute('class');
          }
          this.setAttribute('class', 'same-as-selected');
          selectedDiv.click();
        });
        optionsDiv.appendChild(optionDiv);
      }
      customSelects[i].appendChild(optionsDiv);

      selectedDiv.addEventListener('click', function (e) {
        e.stopPropagation();
        closeAllSelect(this);
        //@ts-ignore
        this.nextSibling.classList.toggle('select-hide');
        this.classList.toggle('select-arrow-active');
      });
    }

    document.addEventListener('click', closeAllSelect);
};

export default customSelect;
